/*
 * @Description:
 * @Date: 2024-01-11 14:07:18
 */

const views = (require as any).context(
  './',
  true,
  /pc-module-catalogue-\d+\.vue/
);

export default views.keys().map(path => {
  return views(path).default;
});

export const cataloguePaddingConfig = {
  'pc-module-catalogue-1': [90, '14%', 100, '40%'],
  'pc-module-catalogue-2': [60, '10%', 20, '10%'],
  'pc-module-catalogue-3': [160, '10.5%', 120, '26.7%'],
  'pc-module-catalogue-4': [260, '10.5%', 40, 140],
  'pc-module-catalogue-5': [100, '19%', 100, '19%'],
  'pc-module-catalogue-6': [180, '12%', 200, '27%']
};
